'use client';

import type { PageBreadcrumbItem } from '@/lib/routing/pageBreadcrumbs';
import PageBreadcrumbsBar from '../shared/PageBreadcrumbsBar';

export type SpecialBreadcrumbItem = { label: string; href?: string };

export default function SpecialBreadcrumbs({
  homeLabel,
  items,
}: {
  homeLabel: string;
  items: readonly SpecialBreadcrumbItem[];
}) {
  const crumbs: PageBreadcrumbItem[] = [
    { label: homeLabel, href: '/' },
    ...items.map((item, index) => ({
      label: item.label,
      href: index < items.length - 1 ? item.href : undefined,
    })),
  ];

  return <PageBreadcrumbsBar items={crumbs} />;
}
